import React, { useState } from 'react';
import { HiOutlineEnvelope } from 'react-icons/hi2';
import ReauthField from './ReauthField';
import ReauthForm from './ReauthForm';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { REAUTH_TEXT_KEYS } from './reauthTexts';

const ReauthOtpForm = ({ isSubmitting = false, onSubmit, onLeave }) => {
  const [otp, setOtp] = useState('');

  const { tempedgeTranslator: text } = useTempEdgeTranslator();
  const canSubmit = Boolean(otp.trim()) && !isSubmitting;

  const handleSubmit = () => onSubmit(otp.trim());

  const handleOtpChange = (event) => setOtp(event.target.value);

  return (
    <ReauthForm
      testId="reauth-otp-form"
      canSubmit={canSubmit}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      onLeave={onLeave}
      submitTestId="reauth-otp-submit-button"
    >
      <p className="te-reauth-reason">{text(REAUTH_TEXT_KEYS.otpDescription)}</p>
      <ReauthField
        id="reauth-otp"
        label={text(REAUTH_TEXT_KEYS.otpLabel)}
        value={otp}
        onChange={handleOtpChange}
        autoComplete="one-time-code"
        icon={HiOutlineEnvelope}
        autoFocus
        maxLength={10}
      />
    </ReauthForm>
  );
};

export default ReauthOtpForm;
